import { Provider } from '@angular/core';
import { UserPasswordFacade, UserProfileFacade } from '../../root';
import { UserPasswordService } from './user-password.service';
import { UserProfileService } from './user-profile.service';

export const facadeProviders: Provider[] = [
  UserPasswordService,
  UserProfileService,
  {
    provide: UserPasswordFacade,
    useExisting: UserPasswordService,
  },
  {
    provide: UserProfileFacade,
    useExisting: UserProfileService,
  },
];
